<template>
  <div class="menu">

    <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
      :unique-opened="true">

      <!--  unique-opened="true"   -->

      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-s-promotion"></i>
          <span>设备别流程漏斗</span>
        </template>

        <el-menu-item index="2-11"> <router-link to="/retention/xbike/daily"> Retention Xbike
          </router-link></el-menu-item>
        <el-menu-item index="2-21"> <router-link to="/retention/litbike/daily"> Retention Litbike
          </router-link></el-menu-item>
        <el-menu-item index="2-24"> <router-link to="/retention/boombike/daily"> Retention Boombike
          </router-link></el-menu-item>
        <el-menu-item index="2-24"> <router-link to="/retention/boombasic/daily"> Retention Boombasic
          </router-link></el-menu-item>
        <el-menu-item index="2-24"> <router-link to="/retention/ebike/daily"> Retention Ebike
          </router-link></el-menu-item>
        <el-menu-item index="2-24"> <router-link to="/retention/xbike,litbike,boombike/daily"> Retention Pad
          </router-link></el-menu-item>
        <el-menu-item index="2-24"> <router-link to="/retention/ebike,boombasic/daily"> Retention App
          </router-link></el-menu-item>
        <el-menu-item index="2-24"> <router-link to="/retention/xbike,litbike,boombike,ebike,boombasic/daily"> Retention
            All Types </router-link></el-menu-item>

      </el-submenu>


      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-s-promotion"></i>
          <span>Billing Overview</span>
        </template>

        <el-menu-item index="3-1"> <router-link to="/subsRetention"> Subs Retention  </router-link></el-menu-item>
        <el-menu-item index="3-5"> <router-link to="/subsTrial">   Trial Subscription </router-link></el-menu-item>    
        <el-menu-item index="3-11"> <router-link to="/subsPause"> Pause Subscription  </router-link></el-menu-item>
        <el-menu-item index="3-16"> <router-link to="/subsList"> Subscriptions  </router-link></el-menu-item> 
      </el-submenu>



      <el-submenu index="5">
        <template slot="title">
          <i class="el-icon-s-data"></i>
          <span>T Conversion Rate </span>
        </template>


        <el-menu-item index="5-11"> <router-link to="/trialConversion/xbike/all"> T Conversion Rate Xbike
          </router-link></el-menu-item>
        <el-menu-item index="5-12"> <router-link to="/trialConversion/litbike/all"> T Conversion Rate Litbike
          </router-link></el-menu-item>
        <el-menu-item index="5-13"> <router-link to="/trialConversion/boombike/all"> T Conversion Rate Boombike
          </router-link></el-menu-item>
        <el-menu-item index="5-14"> <router-link to="/trialConversion/boombasic/all"> T Conversion Rate Boombasic
          </router-link></el-menu-item>
        <el-menu-item index="5-15"> <router-link to="/trialConversion/ebike/all"> T Conversion Rate Ebike
          </router-link></el-menu-item>
        <el-menu-item index="5-23"> <router-link to="/trialConversion/xbike,litbike,boombike/all"> T Conversion Rate Pad
          </router-link></el-menu-item>
        <el-menu-item index="5-26"> <router-link to="/trialConversion/ebike,boombasic/all"> T Conversion Rate App
          </router-link></el-menu-item>
        <el-menu-item index="5-32"> <router-link to="/trialConversion/xbike,litbike,boombike,ebike,boombasic/all"> T
            Conversion Rate All </router-link></el-menu-item>




      </el-submenu>

      <el-submenu index="7">
        <template slot="title">
          <i class="el-icon-s-data"></i>
          <span> Churn Rate </span>
        </template>



        <el-menu-item index="7-3"> <router-link to="/churnRate/xbike/daily"> Churn Rate Xbike
          </router-link></el-menu-item>
        <el-menu-item index="7-4"> <router-link to="/churnRate/litbike/daily"> Churn Rate Litbike
          </router-link></el-menu-item>
        <el-menu-item index="7-5"> <router-link to="/churnRate/boombike/daily">Churn Rate Boombike
          </router-link></el-menu-item>
        <el-menu-item index="7-6"> <router-link to="/churnRate/boombasic/daily"> Churn Rate Boombasic
          </router-link></el-menu-item>
        <el-menu-item index="7-7"> <router-link to="/churnRate/ebike/daily"> Churn Rate Ebike
          </router-link></el-menu-item>
        <el-menu-item index="7-11"> <router-link to="/churnRate/xbike,litbike,boombike/daily"> Churn Rate Pad
          </router-link></el-menu-item>
        <el-menu-item index="7-13"> <router-link to="/churnRate/boombasic,ebike/daily"> Churn Rate App
          </router-link></el-menu-item>
        <el-menu-item index="7-17"> <router-link to="/churnRate/xbike,litbike,boombike,boombasic,ebike/daily"> Churn Rate
            All </router-link></el-menu-item>




      </el-submenu>

      <el-submenu index="8">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span> 激活与绑卡 </span> 
        </template>

      
        <el-menu-item index="8-1"> <router-link to="/activateAndBinding"> 激活与绑卡 </router-link>   </el-menu-item>


      </el-submenu>


      <el-submenu index="11">
        <template slot="title">
          <i class="el-icon-bicycle"></i>
          <span> Active Report </span>
        </template>

        <el-menu-item index="11-1"> <router-link to="/activeReport">活跃报告   </router-link> </el-menu-item>
          <el-menu-item index="11-3"> <router-link to="/activeDistribution"> 活跃行为分布 </router-link></el-menu-item>
          <el-menu-item index="11-5"> <router-link to="/aiCourse"> AI Course Participation </router-link></el-menu-item>

          <el-menu-item index="11-6"> <router-link to="/activeDistributionApp/weekly/pad"> App端活跃占比 </router-link></el-menu-item>
        <el-menu-item index="11-8"> <router-link to="/activeNewOld"> 活跃新老设备 </router-link></el-menu-item>
        <el-menu-item index="11-13"> <router-link to="/subsActivePercential"> 付费设备活跃Percential </router-link></el-menu-item>
<!--  <el-menu-item index="7-16"> <router-link to="/engagementPercentage/justRide/all/true"> JUST RIDE 数据分布 </router-link></el-menu-item>
  -->
       

      </el-submenu>


      <el-submenu index="18">
        <template slot="title">
          <i class="el-icon-s-grid"></i>
          <span>COHORT分析</span>
        </template>

        <el-menu-item index="18-3"> <router-link to="/cohortSubs/pad">付费COHORT </router-link></el-menu-item>
          <el-menu-item index="18-7"> <router-link to="/cohortBingding">激活绑卡COHORT </router-link> </el-menu-item>
          
      </el-submenu>


      <el-submenu index="19">
        <template slot="title">
          <i class="el-icon-s-grid"></i>
          <span>Coaches and Courses</span>
        </template>
        <el-menu-item index="19-3">
        <router-link :to="getCoachPerfUrl()">Coach Performance</router-link>
      </el-menu-item>
      </el-submenu>



      <el-submenu index="20">
        <template slot="title">
          <i class="el-icon-info"></i>
          <span>设备管理</span>
        </template>

        <el-menu-item index="20-1"> <router-link to="/devices">激活的设备 </router-link></el-menu-item>
        <el-menu-item index="20-3"> <router-link to="/deviceSelector">筛选设备 </router-link></el-menu-item>
        <el-menu-item index="20-7"> <router-link to="/deviceInfo">设备详情 </router-link></el-menu-item>

        <el-menu-item index="20-11"> <router-link to="/deviceRelation">设备关联维护 </router-link></el-menu-item>
        <el-menu-item index="20-13"> <router-link to="/whitelist">白名单管理 </router-link></el-menu-item>

      </el-submenu>


      <el-submenu index="22">
        <template slot="title">
          <i class="el-icon-info"></i>
          <span> User 管理</span>
        </template>

        <el-menu-item index="22-11"> <router-link to="/userWhitelist"> User 白名单管理 </router-link></el-menu-item>

      </el-submenu>



      <el-submenu index="26">
        <template slot="title">
          <i class="el-icon-key"></i>
          <span>系统管理</span>
        </template>
  
        <el-menu-item index="26-4"> <router-link to="/login">用户登录 </router-link></el-menu-item>
        <el-menu-item index="26-11"> <router-link to="/devLog">开发日志 </router-link></el-menu-item>
        <el-menu-item index="26-14"> <router-link to="/dashLog">系统日志管理 </router-link></el-menu-item>
        <el-menu-item index="26-17"> <router-link to="/requestApiTest ">Request API Test </router-link></el-menu-item> 
        <el-menu-item index="26-21"> <router-link to="/tools">实用工具 </router-link></el-menu-item>

      </el-submenu>


      <el-submenu index="29">
        <template slot="title">
          <i class="el-icon-s-tools"></i>
          <span>同步信息[慎点]</span>
        </template>

        <el-menu-item index="29-1"> <router-link to="/syncStatus"> 查看同步状态 </router-link></el-menu-item>
        <el-menu-item index="29-2"> <router-link to="/initDevice"> 刷新设备状态 </router-link></el-menu-item>
        <el-menu-item index="29-4"> <router-link to="/dailyRetention"> 按日生成留存信息 </router-link></el-menu-item>
        <el-menu-item index="29-19"> <router-link to="/syncData"> 综合同步数据入口 </router-link></el-menu-item>

      </el-submenu>


    </el-menu>



  </div>
</template>
  
<script>
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getCoachPerfUrl() {
      const currentDate = new Date();
      const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
      const year = previousMonth.getFullYear();
      const month = (previousMonth.getMonth() + 1).toString().padStart(2, '0');
      const formattedYearMonth = `${year}-${month}`;
      return `/coachPerf/${formattedYearMonth}`;
    }


  }
}
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-menu {
  background-color: rgb(166, 174, 183);
}


.el-submenu {
  background-color: rgb(166, 174, 183);
}

.el-menu-item {
  background-color: rgb(218, 223, 229);
}
</style>